var _g, _g2, _g3, _rect, _path, _rect2, _path2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceLanguageLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 145,
    viewBox: "0 0 285 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 39,
    width: 64,
    height: 64,
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.001 55.6152L35.001 60.5383",
    stroke: "white",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7695 60.5381L20.2311 60.5381",
    stroke: "white",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8472 60.5381V60.5381C42.0588 70.8397 34.5717 79.2209 24.6485 83.1488L22.6934 83.9227",
    stroke: "white",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1547 60.5381V60.5381C27.9432 70.8397 35.4303 79.2209 45.3534 83.1488L47.3086 83.9227",
    stroke: "white",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 39,
    width: 64,
    height: 64,
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.001 55.6152L131.001 60.5383",
    stroke: "white",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 60.5381L116.231 60.5381",
    stroke: "white",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.847 60.5381V60.5381C138.059 70.8397 130.572 79.2209 120.649 83.1488L118.693 83.9227",
    stroke: "white",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.155 60.5381V60.5381C123.943 70.8397 131.43 79.2209 141.353 83.1488L143.309 83.9227",
    stroke: "white",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 31,
    width: 80,
    height: 80,
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.001 51.7686L227.001 57.9224",
    stroke: "white",
    strokeWidth: 6.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.462 57.9229L208.539 57.9229",
    stroke: "white",
    strokeWidth: 6.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.309 57.9229V57.9229C235.823 70.7999 226.464 81.2763 214.06 86.1862L211.616 87.1536",
    stroke: "white",
    strokeWidth: 6.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.692 57.9229V57.9229C218.178 70.7999 227.537 81.2763 239.941 86.1862L242.385 87.1536",
    stroke: "white",
    strokeWidth: 6.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 101L159.5 105L166.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 101L63.5 105L70.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 143,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 20,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 134.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 118.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.5,
    cy: 127.5,
    r: 1.5,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.5,
    cy: 30.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.5,
    cy: 31.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 8.5L192 21.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 5L245 20",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M231.5 126.5L234 140",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9754"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 39,
    width: 64,
    height: 64,
    rx: 24.6154,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9754"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 39,
    width: 64,
    height: 64,
    rx: 24.6154,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9754"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 31,
    width: 80,
    height: 80,
    rx: 30.7692,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceLanguageLearning);
export default __webpack_public_path__ + "static/media/persistence-language-learning.1ffbb8a3d21e86854b6589a265a57e7b.svg";
export { ForwardRef as ReactComponent };